import { steps } from '../../../../shared/dataSteps';
import Step from './Step';
import './Steps.scss';

const Steps = () => {
  return (
    <div className="steps">
      <h3 className="title small">4 Easy Steps</h3>
      {steps.map((step) => (
        <Step key={step.id} {...step} />
      ))}
    </div>
  );
};

export default Steps;
